import { render, staticRenderFns } from "./GroupTabs.vue?vue&type=template&id=ac3bf528&scoped=true"
import script from "./GroupTabs.vue?vue&type=script&lang=js"
export * from "./GroupTabs.vue?vue&type=script&lang=js"
import style0 from "./GroupTabs.vue?vue&type=style&index=0&id=ac3bf528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3bf528",
  null
  
)

export default component.exports